import { render, staticRenderFns } from "./liveCourse.vue?vue&type=template&id=9ef9a69a&scoped=true"
import script from "./liveCourse.vue?vue&type=script&lang=js"
export * from "./liveCourse.vue?vue&type=script&lang=js"
import style0 from "./liveCourse.vue?vue&type=style&index=0&id=9ef9a69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef9a69a",
  null
  
)

export default component.exports